import React from 'react';
import { makeStyles } from '@mui/styles';

import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';

const useStyles = makeStyles(theme => ({
    root: {
        minWidth: 150,
    }
}));

function ConfirmationDialog(props) {
    const classes = useStyles();
    const { onClose, onOK, open, onDone, title, message, warning, cancelLabel, okLabel, doneLable, nook, nocancel, done, ...rest } = props;
    return (
        <Dialog
            // disableBackdropClick={false}
            disableEscapeKeyDown={false}
            maxWidth="xs"
            aria-labelledby={props.title}
            onClose={onClose}
            open={open}
            {...rest}>
            <DialogTitle id="confirmation-dialog-title" className={classes.root}>
                {props.title || 'Confirmation'}
            </DialogTitle>
            <DialogContent dividers>
                {props.message}
                <br />
                <br />
                {props.warning}
            </DialogContent>
            <DialogActions>
                {!nocancel &&
                    <Button autoFocus onClick={props.onClose} color="primary" aria-label="cancel">
                        {props.cancelLabel || 'Cancel'}
                    </Button>
                }
                {!nook &&
                    <Button onClick={props.onOK} color="primary" aria-label="ok" disabled={props.disableOK || false}>
                        {props.okLabel || 'OK'}
                    </Button>
                }
                {done &&
                    <Button onClick={props.onDone} color="primary" aria-label="done">
                        {props.doneLabel || 'Done'}
                    </Button>
                }
            </DialogActions>
        </Dialog>
    );
}

ConfirmationDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    onOK: PropTypes.func.isRequired,
    onDone: PropTypes.func,
    open: PropTypes.bool.isRequired,
    message: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    warning: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node
    ]),
    title: PropTypes.string,
    cancelLabel: PropTypes.string,
    okLabel: PropTypes.string,
    nook: PropTypes.bool,
    done: PropTypes.bool,
    nocancel: PropTypes.bool,
    disableOK: PropTypes.bool,
};

export default ConfirmationDialog;
